module.exports = __webpack_public_path__ + "img/CARTE-VISITE-RECTO.357c3a90.jpg";